import { useEffect, useRef, useState } from 'react'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'
import clsx from 'clsx'

import styles from './CallToActionButton.module.scss'

interface CallToActionButtonProps {
  type?: 'button' | 'submit' | 'reset'
  loading?: boolean
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  children?: React.ReactNode
  className?: string | null
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const CallToActionButton = ({
  type = 'button',
  loading = false,
  leftIcon = null,
  rightIcon = null,
  children,
  className = null,
  ...props
}: CallToActionButtonProps) => {
  const [innerLoading, setInnerLoading] = useState(!!loading)
  const buttonRef = useRef(null)

  useEffect(() => {
    setInnerLoading(loading)
  }, [loading])

  const handleClick = (e) => {
    const { onClick } = props

    if (innerLoading) {
      e.preventDefault()
      e.stopPropagation()
      return
    }

    onClick?.(e)
  }

  const classes = clsx(styles.wrapper, {
    [className]: className,
  })

  return (
    <button
      {...props}
      ref={buttonRef}
      className={classes}
      type={type}
      onClick={handleClick}
    >
      {leftIcon && (
        <span className={styles.icon}>
          {innerLoading ? <LoadingOutlined /> : leftIcon}
        </span>
      )}

      <span className={styles.content}>{children}</span>

      {rightIcon && (
        <span className={styles.icon}>
          {innerLoading ? <LoadingOutlined /> : rightIcon}
        </span>
      )}
    </button>
  )
}

CallToActionButton.displayName = 'CallToActionButton'

export default CallToActionButton
